import {
  SET_VENDORACCESS,
  CLEAR_VENDORACCESS,
  LOG_OUT,
} from "../types";

const initialState = null;

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_VENDORACCESS:
      return {
        vendor_id: action.payload.id,
        redirect_back_url: action.payload.redirect_back_url
      };
    case CLEAR_VENDORACCESS:
      return null;
    case LOG_OUT: {
      return {
        ...state,
        vendor_id: "",
      };
    }
    default:
      return state;
  }
}
